/**
 * Přepne stav elementu (button nebo link) na loading a zpět
 * @param {HTMLElement} element - Tlačítko nebo odkaz
 * @param {boolean} isLoading - True pro zapnutí, False pro vypnutí
 */
function toggleButtonLoading(element, isLoading) {
    const el = element; // Není nutné balit do jQuery, pracujeme s nativním DOM

    if (!el) return;

    // Zjistíme, jestli je to odkaz nebo button
    const isLink = el.tagName.toLowerCase() === 'a';

    if (isLoading) {
        el.classList.add('btn-loading');

        if (isLink) {
            el.classList.add('disabled'); // Bootstrap styl pro disabled linky
            el.style.pointerEvents = 'none'; // Fyzicky zabrání klikání
        } else {
            el.disabled = true; // Standardní HTML atribut pro buttony
        }

        // Vytvoříme kontejner pro spinner, pokud tam ještě není
        if (!el.querySelector('.btn-spinner-overlay')) {
            const spinnerOverlay = document.createElement('div');
            spinnerOverlay.className = 'btn-spinner-overlay';
            // Použijeme flexbox a absolutní pozici definovanou v CSS
            spinnerOverlay.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';
            el.appendChild(spinnerOverlay);
        }
    } else {
        el.classList.remove('btn-loading');

        if (isLink) {
            el.classList.remove('disabled');
            el.style.pointerEvents = ''; // Vrátíme do výchozího stavu
        } else {
            el.disabled = false;
        }

        // Odstraníme spinner
        const spinner = el.querySelector('.btn-spinner-overlay');
        if (spinner) {
            spinner.remove();
        }
    }
}


window.toggleButtonLoading = toggleButtonLoading;
//
// // POUŽITÍ:
// const myButton = document.getElementById('saveBtn');
//
// // Zapnout loading
// setButtonLoading(myButton, true);
//
// // Vypnout loading (např. po dokončení AJAXu)
// setTimeout(() => {
//     setButtonLoading(myButton, false);
// }, 2000);
